var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.896107C0 0.485676 0 0.28046 0.0855759 0.167337C0.160128 0.0687876 0.274077 0.0078038 0.397429 0.000438705C0.539022 -0.0080155 0.709771 0.105818 1.05127 0.333484L5.49533 3.29619C5.77751 3.48431 5.9186 3.57837 5.96776 3.69692C6.01075 3.80057 6.01075 3.91706 5.96776 4.02071C5.9186 4.13926 5.77751 4.23332 5.49533 4.42144L1.05127 7.38415C0.709771 7.61181 0.539022 7.72565 0.397429 7.71719C0.274077 7.70983 0.160128 7.64884 0.0855759 7.55029C0 7.43717 0 7.23195 0 6.82152V0.896107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.bcfc921741b25ebd464fe91c64303ebd.svg";
export { ForwardRef as ReactComponent };